import React, { Component } from "react";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";

let TeamContent = [
    {
        images: '01',
        title: 'Hassan Massarwe',
        designation: 'CEO Full stack Uxer & Financial Consultant',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
            {
                icon: <FaTwitter />,
                url: '#'
            },
        ]
    },
    {
        images: '02',
        title: 'Yara Hussein ',
        designation: 'React & Next js Expert',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
        ]
    },
    // {
    //     images: '03',
    //     title: 'Mouhamad Khlayleh ',
    //     designation: 'Full stack Developer',
    //     socialNetwork: [
    //         {
    //             icon: <FaFacebookF />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaTwitter />,
    //             url: '#'
    //         },
    //     ]
    // },
    // {
    //     images: '06',
    //     title: 'Burhan Khateeb',
    //     designation: 'Full stack Uxer',
    //     socialNetwork: [
    //         {
    //             icon: <FaFacebookF />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaTwitter />,
    //             url: '#'
    //         },
    //     ]
    // },
    // {
    //     images: '05',
    //     title: 'Qais Al-Qadi ',
    //     designation: 'Industrial Engineer',
    //     socialNetwork: [
    //         {
    //             icon: <FaFacebookF />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: '#'
    //         },
    //     ]
    // },
    {
        images: '08',
        title: 'Ommri Massarwe',
        designation: 'Photographer & Filmmaker ',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
            {
                icon: <FaTwitter />,
                url: '#'
            },
        ]
    },
    {
        images: '07',
        title: 'Saleh Hnoudi ',
        designation: 'Mobile App Developer',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
            {
                icon: <FaTwitter />,
                url: '#'
            },
        ]
    },
    {
        images: '11',
        title: 'Mouhamad Mansour',
        designation: 'React Expert',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
            {
                icon: <FaTwitter />,
                url: '#'
            },
        ]
    },
    // {
    //     images: '09',
    //     title: 'Nosaiba Mahamid',
    //     designation: 'Front End Developer',
    //     socialNetwork: [
    //         {
    //             icon: <FaFacebookF />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaTwitter />,
    //             url: '#'
    //         },
    //     ]
    // },
    // {
    //     images: '12',
    //     title: 'Zoubayer Qunbar ',
    //     designation: 'Full satck Developer',
    //     socialNetwork: [
    //         {
    //             icon: <FaFacebookF />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaTwitter />,
    //             url: '#'
    //         },
    //     ]
    // },
    
    {
        images: '10',
        title: 'Hala Adeeleh ',
        designation: 'Administrative Assistant',
        socialNetwork: [
            {
                icon: <FaFacebookF />,
                url: '#'
            },
            {
                icon: <FaLinkedinIn />,
                url: '#'
            },
            {
                icon: <FaTwitter />,
                url: '#'
            },
        ]
    },
    // {
    //     images: '13',
    //     title: 'Yahya Farrah ',
    //     designation: 'Specialist in Shopify CMS',
    //     socialNetwork: [
    //         {
    //             icon: <FaFacebookF />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaLinkedinIn />,
    //             url: '#'
    //         },
    //         {
    //             icon: <FaTwitter />,
    //             url: '#'
    //         },
    //     ]
    // }


];


class Team extends Component{
    render(){
        const {column} = this.props;
        return(
            <React.Fragment>
                {TeamContent.map((value , i ) => (
                    <div className={`${column}`} key={i}>
                        <div className="team">
                            <div className="thumbnail">
                                <img src={`/assets/images/team/team-${value.images}.jpg`} alt="Blog Images"/>
                            </div>
                            <div className="content">
                                <h4 className="title">{value.title}</h4>
                                <p className="designation">{value.designation}</p>
                            </div>
                            <ul className="social-icon" >
                                {value.socialNetwork.map((social, index) =>
                                    <li key={index}><a href={`${social.url}`}>{social.icon}</a></li>
                                )}
                            </ul>
                        </div>
                    </div>
                ))}
            </React.Fragment>
        )
    }
}
export default Team;